import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { PermissionRoles } from "../models/models";

export interface initializeApp {
    theme?: string,
    initialized: boolean,
    role: PermissionRoles | undefined,
    permissions: string[],
    userName: string,
    token: string,
    userId: number
}

export const initialState: initializeApp = {
    theme: 'dark',
    initialized: false,
    role: "user",
    permissions: [],
    userName: "",
    token: "",
    userId: -1
}

const initializeAppSlice = createSlice({
    initialState,
    name: 'initializeApp',
    reducers: {
        initializedSuccess: (state, action: PayloadAction<initializeApp>) => {
            const { token, role, permissions, userName, userId, initialized, theme } = action.payload;
            state.token = token;
            state.role = role;
            state.permissions = permissions ?? [];
            state.userId = userId;
            state.userName = userName;
            state.initialized = initialized;
            state.theme = theme;
        },
        initializedFiled: (state) => {
            state.token = "";
            state.role = undefined;
            state.permissions = [];
            state.userId = -1;
            state.userName = "";
            state.initialized = false;
            state.theme = 'dark';
        },
    }
}
)

export const initializedActions = initializeAppSlice.actions;
export default initializeAppSlice;  